export default "__VITE_ASSET__T2aw$b3z__"